<template>
    <div class="d-none d-md-flex flex-column bg-white shadow-sm" id="app_aside">
        <div @mouseenter="show_add_profile_pic()" @mouseleave="hide_add_profile_pic()" class="mx-auto mt-4">
            <div v-if="current_user.profile_image">
                <img :src="current_user.profile_image" alt="user" class="rounded-circle border border-success p-1"
                     height="100"
                     style="border-width: 3px !important; border-color: #00bea5 !important;"
                     width="100">
            </div>
            <div v-else-if="is_authenticated">
                <img @click="$router.push({ path: '/pardakht-shakhsi' })" alt="user"
                     class="rounded-circle border border-success p-1" height="100"
                     src="@/assets/new/image/user_darker.jpeg"
                     style="border-width: 3px !important; border-color: #00bea5 !important; cursor: pointer !important;"
                     v-if="add_profile_pic_on_hover"
                     width="100">
                <img alt="user" class="rounded-circle border border-success p-1" height="100"
                     src="@/assets/new/image/user.jpg"
                     style="border-width: 3px !important; border-color: #00bea5 !important;"
                     v-else
                     width="100">
            </div>
            <div v-else>
                <img alt="user" class="rounded-circle border border-success p-1" height="100"
                     src="@/assets/new/image/user.jpg"
                     style="border-width: 3px !important; border-color: #FF8D8D !important;"
                     width="100">
            </div>
            <div class="h3"
                 id="add_profile_pic"
                 style="display: none;"
                 title="افزودن عکس"
                 v-if="is_authenticated && !current_user.profile_image">
                <i @click="$router.push({ path: '/pardakht-shakhsi' })"
                   class="fas fa-plus"
                   style="cursor: pointer !important;">
                </i>
            </div>

        </div>

        <div class="zp-sidebar"
             style="
            height: 20px;
            line-height: 10px;
            background-color: #00bea5;
            padding:2% 3%;
            color: white;
            text-align: center;
            position: relative;
            margin:0 auto;
            border-radius: 50px;
            top:-10px;
      " v-if="status == 'success'">
            <span class="en_num">ID : {{ current_user.id }}</span>
        </div>
        <div class="h5 text-dark text-center text-white-in-dark-mode" v-if="status == 'success'">
            <span v-if="current_user.user_type == user_types.LEGAL">{{ current_user.com_name_fa }}</span>
            <span v-else>{{ current_user.first_name + ' ' + current_user.last_name }}</span>
        </div>
        <!-- Rating Aside -->
        <div class="h5 text-dark text-center text-white-in-dark-mode" v-if="status == 'success'">
            <div v-if="current_user.user_level==1">
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
                <i aria-hidden="true" class="la la-star-o"></i>
                <i aria-hidden="true" class="la la-star-o"></i>
            </div>
            <div v-else-if="current_user.user_level==2">
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
                <i aria-hidden="true" class="la la-star-o"></i>
            </div>
            <div v-else-if="current_user.user_level==3">
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
                <i aria-hidden="true" class="la la-star" style="color: yellow"></i>
            </div>
            <div v-else>
                <i aria-hidden="true" class="la la-star-o"></i>
                <i aria-hidden="true" class="la la-star-o"></i>
                <i aria-hidden="true" class="la la-star-o"></i>
            </div>
        </div>

        <hr class="sidebar_hr">

        <div id="sidebar_menu">
            <ul class="list-unstyled">
                <li :class="item.url == $route.fullPath ? 'sidebar_active_item sidebar_item' : 'sidebar_item'"
                    :key="index"
                    v-for="(item, index) in menu">
                    <router-link :to="item.url" v-if="is_authenticated || !item.need_auth">
                        <span v-html="item.icon"></span>
                        <span class="pr-2">{{ item.title }}</span>
                        <span v-if="item.title === 'تنظیمات' && setting_badge" class="mx-2">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                        </span>
                    </router-link>
                    <span style="cursor: not-allowed !important;" v-else>
                        <svg fill="#a0a0a0" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g
                            fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path
                            d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
                        <span class="pr-2">{{ item.title }}</span>
                    </span>
                </li>
<!--                <li>-->
<!--                    <a  :href="`https://my.paystar.shop/login/${userToken}/${userData}`" v-if="is_authenticated">-->
<!--                        <SocialStoreSvg />-->
<!--                        <span class="pr-2">{{ $t("label.redirectToStarshopBtn") }}</span>-->
<!--                    </a>-->
<!--                </li>-->
            </ul>
        </div>
        <div class="mt-auto mx-3">
            <router-link
                :class="['btn btn-block btn-outline-secondary rounded-pill', shouldFlash ? 'animated flash' : '']"
                to="/tickets">
                <traning-and-support-svg></traning-and-support-svg>
                <span class="pr-2 text-secondary">آموزش و پشتیبانی</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import aside_menu from "@/components/main/aside.js";
import SocialStoreSvg from '../svg/SocialStoreSvg.vue'
import TraningAndSupportSvg from '../svg/TraningAndSupportSvg.vue'
import {mapGetters} from "vuex";
import {userTypes} from '@/constants/userTypes';
import {getToken} from '@/common/jwt.service.js';
import {PEGEN_LOGIN, SEPEHR_LOGIN, SHOP_LOGIN} from "@/common/config";

export default {
    data() {
        return {
            user_types: userTypes,
            add_profile_pic_on_hover: false,
            menu: aside_menu,
            userToken : localStorage.getItem("access_token"),
            userData : localStorage.getItem("user")
        }
    },
    components: {
        SocialStoreSvg,
        TraningAndSupportSvg
    },
    computed: {
        ...mapGetters('user', [
            'is_authenticated',
            'is_authenticated_pending',
            'current_user',
            'status',
            'dataCount'
        ]),
        shouldFlash() {
            return ((String(window.localStorage.getItem('support_page_visited')) !== '1') && (String(window.localStorage.getItem('is_first_page')) === '1'));
        },
        setting_badge() {
            return this.dataCount.pending_online_contracts > 0
        }
    },
    methods: {
        show_add_profile_pic() {
            $('#add_profile_pic').fadeIn();
            this.add_profile_pic_on_hover = true;
        },
        hide_add_profile_pic() {
            $('#add_profile_pic').fadeOut();
            this.add_profile_pic_on_hover = false;
        },
        redirectToShop() {

            if (this.checkSepehrShopUser()) {
                let link = document.createElement("a");
                link.href = SEPEHR_LOGIN + "/panel";
                document.body.appendChild(link);
                link.click();
            } else if (!this.checkPegenShopUser()) {
                let token = getToken();
                let link = document.createElement("a");
                link.href = SHOP_LOGIN + "/panel/" + token;
                document.body.appendChild(link);
                link.click();
            } else if (this.checkSepehrShopUser()) {
                let link = document.createElement("a");
                link.href = SEPEHR_LOGIN + "/panel";
                document.body.appendChild(link);
                link.click();
            } else {
                let token = getToken();
                let link = document.createElement("a");
                link.href = PEGEN_LOGIN + "/panel/" + token;
                document.body.appendChild(link);
                link.click();
            }
        },

        checkPegenShopUser() {
            let shop = localStorage.getItem('shop_name');
            return shop === 'pegen.ir';

        },

        checkSepehrShopUser() {
            let shop = localStorage.getItem('shop_name');
            return shop === 'sepehr.store';

        }
    },
    mounted() {
        this.$store.dispatch('user/countData')
    }
}
</script>

<style scoped>
.container-text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    background-color: #f1f1f1;
    overflow: hidden;
}

.borders {
    font-size: 13px;
    font-weight: bold;
    /*color: #333;*/
    padding: 10px 20px;
    border-bottom: 2px solid #00b894;
    border-radius: 30px;
    position: relative;
    animation: rotateAnimation 1s linear infinite;

}

@keyframes rotateAnimation {
    0% {
        transform: rotate(0deg);
    }
    25% {
        border-bottom: none;
        border-left: 2px solid #00b894;
        /*transform: rotate(0deg);*/
    }
    50% {
        border-left: none;
        border-top: 2px solid #00b894;
        /*transform: rotate(0deg);*/
    }
    75% {
        border-top: none;
        border-right: 2px solid #00b894;
        /*transform: rotate(0deg);*/
    }
    100% {
        transform: rotate(360deg);
    }
}

#add_profile_pic {
    height: 1px;
    width: 60px;
    text-align: center;
    position: relative;
    margin: auto;
    border-radius: 10px;
    top: -50px;
    right: 0px;
    color: #00bea5;
}
</style>
